import { apiClient } from './client';

export interface GoalStatusDto {
  statusId: number;
  statusName: string;
  description?: string;
  displayOrder?: number;
  backgroundColor: string;
  textColor: string;
  isActive: boolean;
}

export const goalStatusesApi = {
  list: async (): Promise<GoalStatusDto[]> => {
    return await apiClient.get<GoalStatusDto[]>('/api/goal-statuses');
  },

  getById: async (id: number): Promise<GoalStatusDto> => {
    return await apiClient.get<GoalStatusDto>(`/api/goal-statuses/${id}`);
  },
};
